<template>
  <div id="page_app">
    <v-container fluid>

      <v-tabs v-model="tab">
        <v-tab>General</v-tab>
        <v-tab>API Key</v-tab>
        <v-tab-item>
          <v-flex lg12 md12 sm12 xs12>
            <v-card-text class="text-xs-left">
              <v-skeleton-loader v-if="loading" type="article, actions"/>
              <v-form   v-if="!loading" v-model="valid" ref="form" lazy-validation>
                <v-row>
                  <v-col cols="12" md4="2" lg="2">
                    <div class="imgslide justify-center align-center">
                      <img
                              id="logoapp"
                              class="imgslide justify-center align-center"
                              :src="application.logo"
                              alt="image"
                              @click="openfile()"
                              width
                              height="96px"
                      /></div>
                    <v-btn @click="openfile()" ripple text>
                      <v-icon>edit</v-icon>
                      Ganti Logo</v-btn>
                    <v-progress-circular
                            :size="70"
                            :width="2"
                            v-if="loadingupload"
                            color="red"
                            indeterminate
                    ></v-progress-circular>
                  </v-col>
                  <v-col cols="12" md="10" lg="8">
                    <v-row>
                      <v-col cols="12" md="4" lg="4">
                        <v-text-field
                                :rules="Rules"
                                required
                                label="App Name"
                                name="name"
                                v-model="application.appname"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="4" lg="4">
                        <v-text-field
                                label="Server ID"
                                name="version"
                                :rules="Rules"
                                required
                                v-model="application.appcode"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-col cols="12" md="4" lg="8">
                      <v-row>
                        <v-text-field label="Tagline" name="tagline" v-model="application.tagline"></v-text-field>
                      </v-row>
                    </v-col>
                    <v-row>
                      <v-col cols="12" md="4" lg="4">
                        <v-select
                                label="Register Online"
                                item-text="text"
                                item-value="regonline"
                                v-model="application.regonline"
                                :items="regonlines"
                        ></v-select>
                      </v-col>
                      <v-col cols="12" md="4" lg="4">
                        <v-select
                                label="Metode Register"
                                item-text="text"
                                item-value="regmethod"
                                v-model="application.regmethod"
                                :items="regmethods"
                        ></v-select>
                      </v-col>
                    </v-row>
                    <v-col cols="12" md="8" lg="8">
                      <v-row>
                        <v-text-field
                                label="Zopim Account Key"
                                :error="error_input"
                                name="zopim_key"
                                v-model="application.zopimkey"
                        ></v-text-field>
                      </v-row>
                    </v-col>
                    <v-col cols="12" md="8" lg="8">
                      <v-row>
                        <v-text-field
                                label="API URL"
                                :rules="Rules"
                                required
                                :error="error_input"
                                name="version"
                                v-model="application.apiurl"
                        ></v-text-field>
                      </v-row>
                    </v-col>
                    <v-col cols="12" md="8" lg="8">
                      <v-row>
                        <v-text-field
                                label="API KEY"
                                :rules="Rules"
                                required
                                :error="error_input"
                                name="version"
                                v-model="application.appkey"
                        ></v-text-field>
                      </v-row>
                    </v-col>
                    <v-row>
                      <v-col cols="12" md="4" lg="4">
                        <div>
                          <span>Warna</span>
                        </div>
                        <input
                                id="background-color-darkx"
                                class="warna"
                                type="color"
                                v-model="application.primarycolordark"
                        />

                      </v-col>
                    </v-row>

                    <v-col cols="12" md="4" lg="8">
                      <v-row>
                        <v-spacer></v-spacer>
                        <v-btn :disabled="!valid || loadingupload" color="success" @click="simpanForm(application)">Simpan</v-btn>
                      </v-row>
                    </v-col>
                  </v-col>
                </v-row>
                <v-flex lg6 sm12 xs12>
                  <input
                          hidden
                          name="imageupload"
                          type="file"
                          accept="image/*"
                          ref="imageupload"
                          v-on:change="upload($event.target.files)"
                  />
                </v-flex>
              </v-form>
            </v-card-text>
          </v-flex>
        </v-tab-item>
        <v-tab-item>
          <v-flex lg12 md12 sm12 xs12>
            <v-col cols="12" lg="6" md="6">
              <v-text-field readonly v-model="application.serverkey" label="API KEY"></v-text-field>
            </v-col>
          </v-flex>
        </v-tab-item>
      </v-tabs>
      </v-container>
  </div>
</template>

<script>
  import moment from 'moment';
import { mapState, mapActions } from 'vuex'
export default {
  data: () => ({
    state_add: false,
    tab: null,
    search: '',
    ladingx:true,
    valid: false,
    tabs:null,
    toggle:false,
    settings: [],
    bayartempo:false,
    tabsitems: [
      'General'
    ],
    error_input: false,
    Rules: [v => !!v || 'Please fill value'],
    regonlines: [
      {
        regonline: 1,
        text: 'YES'
      },
      {
        regonline: 0,
        text: 'NO'
      }
    ],
    regmethods: [
      {
        regmethod: 0,
        text: 'Form'
      },
      {
        regmethod: 1,
        text: 'Simple'
      }
    ],
    complex: {
      selected: [],
      headers: [
        {
          text: 'Logo',
          value: 'logo'
        },
        {
          text: 'App Name',
          value: 'appname'
        },
        {
          text: 'Tagline',
          value: 'tagline'
        },
        {
          text: 'Server ID',
          value: 'appcode'
        },
        {
          text: 'Version',
          value: 'version'
        },
        {
          text: 'Primary Color',
          value: 'primary_color'
        },
        {
          text: 'Color Dark',
          value: 'primary_color_dark'
        },
        {
          text: 'updated At',
          value: 'update_at'
        },
        {
          text: 'Action',
          value: 'action'
        }
      ],
      items: []
    },
    addApp: {
      appname: '',
      logo: '',
      api_url: '',
      appkey: '',
      tagline: '',
      serverkey: 'firebase server key',
      version: '1.0',
      primary_color: '#3F51B5',
      primary_color_dark: '#3949AB',
      zopim_key: '',
      regonline: 1,
      regmethod: 0
    }
  }),
  watch: {

  },
  created () {
    // this.getApplist();
  },
  mounted () {
    this.getApplist()
    this.resetimage()
  },
  computed: {
    ...mapState('applikasi', ['applist','application', 'dialog', 'loading']),
    ...mapState('UploadImage', ['defaultimg','loadingupload'])
  },
  methods: {
    ...mapActions({
      logout: 'account/logout',
      EditApp: 'applikasi/EditApp',
      closeDialog: 'applikasi/closeDialog',
      OpenDialogForm: 'applikasi/OpenDialogForm',
      getApplist: 'applikasi/getApplist',
      uploadImage: 'UploadImage/uploadImage',
      resetimage:'UploadImage/resetimage'
    }),

    formattanggal(tgl){
      return moment(tgl).format("HH:mm:ss YYYY/MM/DD ")
    },
    closeform () {
      this.clearItems()
      this.closeDialog()
      this.state_add = false
      this.getApplist()
    },
    async openFormEdit (data) {
      console.log(data);
      this.addApp = data
      this.state_add = false
      await this.OpenDialogForm()
      document.getElementById('logoapp').src = this.addApp.logo
    },
    openmodal () {
      // this.clearItems();
      this.valid = false
      this.state_add = true
      this.OpenDialogForm()
      document.getElementById('logoapp').src =
        'https://res.cloudinary.com/irsmax/image/upload/v1556867559/upload_placeholder.png'

    },
    simpanForm (data) {
      if (data.api_url === '') {
        this.error_input = true
        this.valid = false
      }

      if (data.appkey === '') {
        this.error_input = true
        this.valid = false
      }
      if (this.valid) {
        if(this.defaultimg.length>0){
          data.logo=this.defaultimg
        }
        this.EditApp(data)
        this.state_add = false
      }
      this.clearItems()
    },
    deleteItem: function (dialog, data) {
      console.log('okmantap')
      console.log(data)
      dialog.close()
    },
    clearItems () {
      this.addApp.id = null
      this.addApp.appname = ''
      this.addApp.logo =
        'https://res.cloudinary.com/irsmax/image/upload/v1556867559/upload_placeholder.png'
      this.addApp.tagline = ''
      this.addApp.serverkey = ''
      this.addApp.version = '1.0'
      this.addApp.appkey = ''
      this.addApp.api_url = ''
      this.addApp.app_code = ''
      this.addApp.primary_color = '#3F51B5'
      this.addApp.primary_color_dark = '#3949AB'
    },
    upload: function (files) {
      this.addApp.logo = files[0]
      this.showPreview(files[0])
    },
    showPreview: function (file) {
      var reader = new FileReader()
      console.log(file)
      if(file){
        this.uploadImage(file);
      }
      reader.onload = function (e) {
        document.getElementById('logoapp').src = e.target.result
      }
      reader.readAsDataURL(file)
    },
    openfile () {
      document.getElementsByName('imageupload')[0].click()
    }
  }
}
</script>

<style scoped>
.warna {
  height: 50px;
}
.imgslidelist {
  width: 96px;
  height: 96px;
  padding: 2px;
}
</style>
